import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Grid,
  Typography,
  TextField,
  Button,
  Switch,
} from '@material-ui/core';
import { Formik } from 'formik';
import * as yup from 'yup';
import { saveTermsAndConditionsAPI } from 'api';
import { BackdropCircular } from 'components';


const EditAgreement = ({ setOpenEditAgreementDialog, editableAgreement, setEditableAgreement }) => {
  const dispatch = useDispatch();
  const {loadingTermsAndConditions} = useSelector((state) => state.quote);

  const handleSubmit = async (values) => {
    if (values.isSubscription) {
      values.name = `Sarp ${values.name}`;
    }

    const { isSubscription, ...valuesToSend } = values;

    await saveTermsAndConditionsAPI({ dispatch, agreement: valuesToSend });

    setEditableAgreement({});
    setOpenEditAgreementDialog(false);
  };

  return (
    <div className="pt-10 pl-6">
      <Formik
        initialValues={{
          agreement_id: editableAgreement.agreement_id || null,
          name: editableAgreement.name || '',
          checkbox_text: editableAgreement.checkbox_text || '',
          content: editableAgreement.content || '',
          is_active: editableAgreement.is_active || true,
          isSubscription: editableAgreement.isSubscription || false,
          is_html: editableAgreement.is_html || false,
          mode: editableAgreement.mode || 1
        }}
        enableReinitialize
        validationSchema={
          yup.object({
            name: yup
              .string()
              .required('Field is required'),
            content: yup
              .string()
              .required('Field is required'),
            checkbox_text: yup
              .string()
              .required('Field is required'),
          })
        }
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue
        }) => {
          return (
            <form onSubmit={handleSubmit} noValidate>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography variant="h5">
                    Agreement Information:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                  Is Subscription
                </Grid>
                <Grid item xs={12} sm={8} md={9}>
                  <Switch
                    color="primary"
                    name="isSubscription"
                    checked={values.isSubscription}
                    onChange={(event) => setFieldValue('isSubscription', event.target.checked)}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                  Rule Name <span className="text-error">*</span>
                </Grid>
                <Grid item xs={12} sm={8} md={9}>
                  <TextField
                    required
                    fullWidth
                    variant="outlined"
                    label="Name"
                    name="name"
                    className="max-w-600"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.name && Boolean(errors.name)}
                    helperText={touched.name && errors.name}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                  Checkbox Text <span className="text-error">*</span>
                </Grid>
                <Grid item xs={12} sm={8} md={9}>
                  <TextField
                    required
                    multiline
                    fullWidth
                    variant="outlined"
                    label="Checkbox Text"
                    name="checkbox_text"
                    className="max-w-600"
                    value={values.checkbox_text}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.checkbox_text && Boolean(errors.checkbox_text)}
                    helperText={touched.checkbox_text && errors.checkbox_text}
                    inputProps={{
                      className: 'p-0'
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                  Content <span className="text-error">*</span>
                </Grid>
                <Grid item xs={12} sm={8} md={9}>
                  <TextField
                    required
                    multiline
                    fullWidth
                    variant="outlined"
                    label="Content"
                    name="content"
                    className="max-w-600"
                    value={values.content}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.content && Boolean(errors.content)}
                    helperText={touched.content && errors.content}
                    inputProps={{
                      className: 'p-0'
                    }}
                  />
                </Grid>
                <Grid item xs={12} className="pt-8">
                  <Button
                    color="primary"
                    variant="contained"
                    className="mr-4"
                    type="submit"
                  >
                    Save
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => {
                      setOpenEditAgreementDialog(false);
                      setEditableAgreement({});
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            </form>
          );
        }}
      </Formik>
      <BackdropCircular loading={loadingTermsAndConditions} />
    </div>
  );
};

export default EditAgreement;
